<template>
  <v-container fluid class="pa-0" :style="$vuetify.breakpoint.xl ? 'border-top:2px solid #323E53;margin-top: 96px;':'border-top:2px solid #323E53;margin-top: 64px;'">
    <v-row class="navigationRow" v-if="hasFeature('newNavigation')" no-gutters>
      <v-col cols="9">
        <div style="width:100%;" class="hideBars">
          <NextToGo :races="getRaces" :selectedRaceId="selectedRace.id" />
          <RaceHeader v-if="selectedRace" :scrollTop="scrollTop" :scrollDown="scrollDown" :runnerOverflow="isRunnerListOverflowing"/>
          <div v-if="selectedRace && selectedRace.id" class="selectionsContainer hideBars mr-2" :style="$vuetify.breakpoint.xl ? 'height:calc(100vh - 380px)':'height:calc(100vh - 315px)'" ref="runnerListEl">
            <RunnerPicker :race="selectedRace"/>
          </div>
          <v-card v-else-if="selectedRace === null" color="warning" class="pa-2 mr-3" dark>
            <div class=" title d-inline">No Race Selected!</div>
          </v-card>
        </div>
      </v-col>
      <v-col cols="3">
        <BetSlip :ticketIdChange="ticketIdChange" :clearStake="clearStake" :ticketId="ticketId" :rejectedTicket="rejectedTicket" :betDetailsChecked="betDetailsChecked"/>
      </v-col>
    </v-row>
    <v-row v-else no-gutters>
      <v-col cols="3">
        <MeetingNavigation :meetings="meetings"/>
      </v-col>
      <v-col cols="9" class="pl-6">
        <div style="width:100%;" class="hideBars">
          <NextToGo :selectedRaceId="selectedRace.id"/>
          <RaceHeader v-if="selectedRace" :scrollTop="scrollTop" :scrollDown="scrollDown"/>
          <div v-if="selectedRace && selectedRace.id" class="selectionsContainer hideBars" >
          <RunnerPicker :race="selectedRace"/>
          </div>
            <v-card v-else-if="selectedRace === null" color="warning" class="pa-2 mr-3" dark>
              <div class=" title d-inline">No Race Selected!</div>
            </v-card>
        </div>
      </v-col>
    </v-row>
    <DialogModal :betDetails="betDetails" :betError="betError" :clearSetStake="clearSetStake" :betStatus="betStatus" :betId="betId" :selectedRaceId="selectedRace.id" :clearModal="clearModal" :refundError="refundError" :alertStake="alertStake" :ticketId="ticketId" :refundModal="refundModal" :refundAmt="refundAmt" :sentBet="sentBet" :reloadRace="reloadRace" :addTransaction="addTransaction"/>
    <MeetingsModal v-if="openMeetingsModal && hasFeature('newNavigation')" @close="setMeetingsModal(false)" :meetingsDated="meetings"/>
    <Receipts :userName="userName"/>
    <v-dialog
        v-model="raceLoading"
        hide-overlay
        persistent
        transition="none"
        width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Selected Race
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="-1"
      :value="appVersion.stale"
      bottom
      left
      transition="none"
      color="warning"
      style="margin-bottom: 30px"
    >
      <b>An update is available.</b>
      <v-btn elevation="0"
        style="margin-left: 10px !important;"
        color="success"
        dark
        @click="refreshPage"
        small
      >
        Update &amp; Reload
      </v-btn>
      <v-btn elevation="0"
        style="margin-left: 18px !important"
        color="primary"
        dark
        small
        @click="dismissNotif"
      >
        Dismiss
      </v-btn>
    </v-snackbar>
    <v-footer height="20" v-if="hasFeature('versionFooter')">
      <h6>{{environment}}---{{appVersion.version}}</h6>
    </v-footer>
  </v-container>
  </template>
  
  <script>
  import BetSlip from '../components/BetSlip'
  import DialogModal from '../components/DialogModal'
  import MeetingNavigation from '../components/MeetingNavigation'
  import NextToGo from '../components/NextToGo'
  import RaceHeader from '../components/RaceHeader'
  import RunnerPicker from '../components/RunnerPicker'
  import MeetingsModal from '../components/MeetingsModal'
  import Receipts from '../components/Receipts'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import axios from 'axios'
  import { Auth } from 'aws-amplify'
  import moment from 'moment'
  import { updateCustomerDisplayPendingBet  } from "../common/customerDisplay"
  
  export default {
    name: 'Home',
    props: {
      refetch: Boolean,
      userName: String
    },
    data() {
      return {
        stake: '$0',
        showLoadDiag: false,
        showThisStakeModal: false,
        showThisBetModal: false,
        alertStake: false,
        sentBet: false,
        betStatus: null,
        betError: null,
        refundAmt: null,
        ticketId: null,
        timeout: null,
        betId: [],
        refundModal: false,
        refundError: false,
        rejectedTicketStr: [],
        betDetails: [],
        firstLoad: null,
        todayDate: moment().startOf('day').format(),
        tomorrowDate: moment().startOf('day').add(1,'d').format(),
        thirdDate: moment().startOf('day').add(2,'d').format(),
        runnerListClientHeight: 0,
        runnerListScrollHeight: 0,
        betSlipClientHeight: 0
      }
    },
    components: {
      MeetingNavigation,
      DialogModal,
      RunnerPicker,
      NextToGo,
      RaceHeader,
      BetSlip,
      MeetingsModal,
      Receipts
    },
    watch: {
      refetch () {
        this.fetchMeetings()
      },
      getSelectedRace (newVal) {
        //we don't want the custoemr display screen been flushed with bet info when it's in multi redemption mode
        if(!this.getMultiRedemptionMode){
          updateCustomerDisplayPendingBet({
          track: newVal.meeting?.track.name,
          race: newVal.name,
        });
        }
  
        //this.updateScannedTickets([])
        this.$nextTick(()=>{
          if(this.$refs.runnerListEl){
   
          const runnerOb = new ResizeObserver(entries => {
          for(let entry of entries){
            this.runnerListClientHeight = entry.target.clientHeight
            this.runnerListScrollHeight = entry.target.scrollHeight
          }
          })
          runnerOb.observe(this.$refs.runnerListEl)
          }
          
        })
      }
    },

    computed: {
      ...mapState(['openMeetingsModal', 'raceLoading', 'appVersion']),
      ...mapGetters(['getTerminalId','hasFeature', 'getRaces', 'getSelectedRace', 'getMeetings','getMultiRedemptionMode']),
      meetings () {
        return this.getMeetings || []
      },
      environment () {
        return process.env.VUE_APP_TITLE
      },
      selectedRace () {
        if (this.getSelectedRace) return this.getSelectedRace
        return {}
      },
      isRunnerListOverflowing(){
        return this.runnerListClientHeight < this.runnerListScrollHeight && !this.$vuetify.breakpoint.xl
      }
    },
    methods: {
      ...mapActions(['clearBets', 'selectMeeting', 'selectRace', 'setMeetingsModal', 'loadPriceCode', 'fetchMeetings','updateScannedTickets']),
      ticketIdChange(v) {
        this.ticketId = v
      },
      refreshPage () {
        window.location.reload()
      },
      dismissNotif () {
        this.appVersion.stale = false
      },
      scrollTop() {
        let content = document.querySelector(".selectionsContainer")
        content.scrollTop -= 150
      },
      scrollDown() {
        let content = document.querySelector(".selectionsContainer")
        content.scrollTop += 150
      },
      betDetailsChecked (v) {
        this.betDetails = v
      },
      clearStake (enteredStake, betStatus, betId, error, refundAmt, ticketId) {
        this.stake = enteredStake
        this.sentBet = true
        this.betStatus = betStatus
        this.betId = betId
        this.betError = error
        this.refundAmt = refundAmt
        this.ticketId = ticketId
        this.showThisBetModal = false
      },
      clearModal () {
        this.refundModal = false,
        this.alertStake = false,
        this.refundError = false
      },
      clearSetStake () {
        this.sentBet = false
        this.stake = '$0'
        this.clearBets()
        this.refundAmt = null
        this.betStatus = null
      },
      rejectedTicket (refundTicketStr, refundAmt) {
        if (!window.refundTicket) {
          window.refundTicket = console.log
        }
        window.refundTicket(JSON.stringify(refundTicketStr))
        this.refundAmt = refundAmt
      },
      async reloadRace () {
        this.sentBet = false
      },
      //this is just never gonna be used as i know, as the dialog is based on alertStake = true, but I can't see anywhere we set the value to true...
      async addTransaction (transAmt, typeId, ticketId) {
        const data = await Auth.currentSession()
        await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/AddTransaction`, {
          terminalId: this.getTerminalId,
          ticketId: ticketId,
          amount: transAmt,
          type: typeId,
        },
        {
          headers: {
          Authorization: 'Bearer ' + data.accessToken.jwtToken,
          },
          credentials: true
        })
        .then(() => {
          this.refundModal = true
          this.refundThisTicket(this.rejectedTicketStr)
        })
        .catch (() => {
          this.refundModal = true
          this.refundThisTicket(this.rejectedTicketStr)
        })
      }
    }
  
  }
  </script>
  
  <style>
    .selectionsContainer {
      
      overflow-y:scroll;
  
    }
  /* Hide scrollbar for Chrome, Safari and Opera */
  .hideBars::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE and Edge */
  .hideBars {
    -ms-overflow-style: none;
  }
  </style>
  